angular.module 'zc.projects'

.controller 'UserInviteCtrl', ($scope, ProjectUser, $state, $stateParams, $translate, currentUser, currentProject) ->
  $scope.availableLanguages = $translate.getAvailableLanguageKeys()
  $scope.user =
    lang: currentUser.lang
  $scope.isDisplayAajsWarningMsg = currentProject.enable_aajs &&
    _.some([
      currentProject.site_id,
      currentProject.tracking_id,
      currentProject.scope_id
    ],
      (item) => !(item && item.length > 0)
    )

  $scope.invite = (project, user) ->
    ProjectUser.create
      projectId: project.id
    ,
      user: user
    .then (user) ->
      $scope.user =
        full_name: ''
        email: ''
        lang: currentUser.lang
      $state.go 'admin.projects.settings.users',
        projectId: $stateParams.projectId



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/users/invite.controller.coffee